// eslint-disable-next-line func-names
function getDuration(startDate, endDate) {
  const durationInMs = endDate.getTime() - startDate.getTime()
  const durationInHours = durationInMs / 1000 / 60 / 60

  return durationInHours
}

function getTimeFormatted(date) {
  const hours = date.getHours()
  const minutes = date.getMinutes()

  return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`
}

export default function formatDuration(startDate, endDate) {
  // eslint-disable-next-line no-param-reassign
  if (!(startDate instanceof Date)) startDate = new Date(startDate)
  // eslint-disable-next-line no-param-reassign
  if (!(endDate instanceof Date)) endDate = new Date(endDate)

  // Obtenemos la hora formateada a HH:mm
  const startTimeFormatted = getTimeFormatted(startDate)
  const endTimeFormatted = getTimeFormatted(endDate)

  // Obtenemos la duración del evento
  const durationInHours = getDuration(startDate, endDate)

  // Obtenemos el día de inicio y el día de fin
  const daysOfWeek = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb']
  const startDayOfWeek = daysOfWeek[startDate.getDay()]
  const endDayOfWeek = daysOfWeek[endDate.getDay()]

  // Obtenemos el mes de inicio y el mes de fin
  const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
  const startMonth = months[startDate.getMonth()]
  const endMonth = months[endDate.getMonth()]

  // Obtenemos las partes de las fechas
  const startDay = startDate.getDate()
  const endDay = endDate.getDate()
  const startYear = startDate.getFullYear()
  const endYear = endDate.getFullYear()

  if (startYear === endYear && startMonth === endMonth && startDay === endDay) {
    return `${startDayOfWeek}. ${startDay} de ${startMonth} de ${startYear}<br \\>${startTimeFormatted}-${endTimeFormatted} (${durationInHours} horas)`
  }
  if (startYear === endYear && startMonth === endMonth) {
    return `${startDayOfWeek}. ${startDay} - ${endDayOfWeek}. ${endDay} de ${startMonth} de ${startYear}<br \\>${startTimeFormatted}-${endTimeFormatted} (${durationInHours} horas)`
  }
  if (startYear === endYear) {
    return `${startDayOfWeek}. ${startDay} de ${startMonth} - ${endDayOfWeek}. ${endDay} de ${endMonth} de ${startYear}<br \\>${startTimeFormatted}-${endTimeFormatted} (${durationInHours} horas)`
  }

  return `${startDayOfWeek}. ${startDay} de ${startMonth} de ${startYear}-${endDayOfWeek}. ${endDay} de ${endMonth} de ${endYear}<br \\>${startTimeFormatted}-${endTimeFormatted} (${durationInHours} horas)`
}
